// @flow

import types from './types';

const getProjects = () => ({
  type: types.GET_PROJECTS_REQUEST,
});

const checkIsDark = () => {
  const isDarkTheme = localStorage.getItem('isDarkTheme') === 'true';
  return {
    type: types.CHECK_IS_DARK,
    payload: !!isDarkTheme,
  };
};
const switchTheme = (isDarkTheme) => {
  localStorage.setItem('isDarkTheme', isDarkTheme);
  return {
    type: types.CHECK_IS_DARK,
    payload: isDarkTheme,
  };
};

export default {
  getProjects,
  checkIsDark,
  switchTheme,
};



// WEBPACK FOOTER //
// ./src/view/duck/actions.js